"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmSaveDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("../../../core");
require("./types");
const ConfirmSaveDialog = ({ isSaveDisabled, isSaved, onSave, onCancel, onConfirm, }) => {
    const { t } = core_1.useFeatureContext();
    const message = isSaveDisabled
        ? t('confirmSaveDialog|message|error')
        : t('confirmSaveDialog|message|confirm');
    react_1.useEffect(() => {
        if (isSaved) {
            onConfirm();
        }
    }, [isSaved]);
    return (react_1.default.createElement(components_1.MessageBox, { header: t('confirmSaveDialog|header'), iconView: components_1.MESSAGE_BOX_ICON_VIEW.warning, onRequestClose: onCancel, actions: [
            {
                id: 'done',
                view: components_1.ACTION_VIEW.primary,
                text: t('confirmSaveDialog|actions|save'),
                disabled: isSaveDisabled,
                onClick: onSave,
            },
            {
                id: 'discard',
                view: components_1.ACTION_VIEW.secondary,
                text: t('confirmSaveDialog|actions|discard'),
                onClick: onConfirm,
            },
            {
                id: 'cancel',
                view: components_1.ACTION_VIEW.secondary,
                text: t('confirmSaveDialog|actions|cancel'),
                onClick: onCancel,
            },
        ] }, message));
};
exports.ConfirmSaveDialog = ConfirmSaveDialog;
//# sourceMappingURL=ConfirmSaveDialog.js.map